import Vue from "vue";
import Vuex from "vuex";

const StepperDemande = {
    namespaced: true,
    state: {
        steps: 6,
        step: 1
    },
    actions: {
        setStep: (context, variable) => {
            context.commit('STEP', variable);
        },
    },
    mutations: {
        STEP: (state, variable) => {
            state.step = variable;
        },
        STEPS: (state, variable) => {
            state.steps = variable;
        },
    },
    getters: {
        steps: state => {
            return state.steps;
        },
        step: state => {
            return state.step
        },
        stepsMap: state => {
            return state.stepsMap;
        }
    },
    // modules: {}
};

export default StepperDemande;